import { Props } from "./Compras.type";
import React, { useEffect } from "react";
import { Loading } from "../../components/common/Loading/Loading";
import { Protected } from "@/components/layout/Protected";
import { Box, Button, Grid} from "@mui/material";
import { styled } from '@mui/material/styles';
import { ROUTE_NUEVA_COMPRA } from "@/toolbox/constants/route-map";
import { compraService } from "@/service/services/Compra.service";
import { ComprasTable } from "./components/ComprasTable";
import { useHistory } from 'react-router-dom';
import {KEY_EDIT_COMPRA, PRODUCTS_CARD, KEY_EDIT_COMPRA_ID, KEY_EDIT_COMPRA_PROVEEDOR_ID} from '@constants/local-storage';
import {
   saveLocalStorage
} from '@helpers/local-storage-helper';

const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    padding: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: '20px',
    color: 'rgba(102, 102, 102, 0.4)',
  }));

const Titulo = styled('div')(({ theme }) => ({
...theme.typography.button,
padding: theme.spacing(1),
fontWeight: 'bold',
fontSize: '20px',
color: 'black',
}));


export const Compras: React.FC<Props> = (props:Props):JSX.Element => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const history = useHistory();
    const [compras, setCompras] = React.useState<Array<any>>([]);
   //  const [orden, setOrder] = React.useState<Array<any>>([]);
   //  const [comprasOnly, setComprasOnly] = React.useState<Array<any>>([]);

    useEffect(() => {
      listCompras();
    }, [])

    const listCompras = async() => {
      setLoading(true);
      await compraService.listCompras().then((data) => {
         // if (data.length > 0) {
         //    let filterNumbers = data.filter(i => i.received_at === null);
         //    setOrder(filterNumbers)
         //    let filters = data.filter(i => i.received_at !!== null);
         //    setComprasOnly(filters)
         // }
         setCompras(data);
         setLoading(false);
      })
    }

    const handleNewCompra = () => {
      localStorage.removeItem(KEY_EDIT_COMPRA);
      localStorage.removeItem(PRODUCTS_CARD);
      localStorage.removeItem(KEY_EDIT_COMPRA_ID);
      localStorage.removeItem(KEY_EDIT_COMPRA_PROVEEDOR_ID);
      saveLocalStorage(PRODUCTS_CARD, []);
      history.push(ROUTE_NUEVA_COMPRA);
    }


    return (
        <Protected>
            {loading && <Loading/>}
            <Box sx={{ marginLeft:'10px',marginRight:'10px', marginBottom:'20px'}}>
                <Grid container justifyContent='space-between' spacing={2}>
                    <Grid item>
                        <Button variant='outlined' onClick={handleNewCompra}
                        >Crear Nueva Compra</Button>
                    </Grid>
                </Grid>
                {/* <Grid
                  container spacing={0} direction="column"
                  alignItems="center" justifyContent="center"
                  style={{ marginBottom: '20px', marginTop:'30px'}}
                  >
                  <Grid item xs={3}>
                     <Titulo>{"Ordenes de compra"}</Titulo>
                  </Grid>
               </Grid>

               {!loading && compras.length !== 0 &&
                  <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px'}}>
                     <ComprasTable compras={orden} onListCompras={listCompras} type="orden" />
                  </Box>
               }
               {!loading && compras.length === 0 &&
                  <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px', justifyContent: 'center',
                  alignItems: 'center', display: 'flex' }} >
                     <Div>{"No se Encontraron Ordenes de Compras"}</Div>
                  </Box>
               }
               {loading &&
                  <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px'}}>
                  </Box>
               } */}

               <Grid
                  container spacing={0} direction="column"
                  alignItems="center" justifyContent="center"
                  style={{ marginBottom: '20px', marginTop:'30px'}}
                  >
                  <Grid item xs={3}>
                     <Titulo>{"Compras realizadas"}</Titulo>
                  </Grid>
               </Grid>

               {!loading && compras.length !== 0 &&
                  <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px'}}>
                     <ComprasTable compras={compras} onListCompras={listCompras} type="compra" />
                  </Box>
               }
               {!loading && compras.length === 0 &&
                  <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px', justifyContent: 'center',
                  alignItems: 'center', display: 'flex' }} >
                     <Div>{"No se Encontraron Compras"}</Div>
                  </Box>
               }
               {loading &&
                  <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px'}}>
                  </Box>
               }
            </Box>
        </Protected>
    );
}
